import { useState, useEffect } from "react"
import { ChevronLeft, ChevronRight, Users, Award, BookOpen, Target, Eye, Heart, HelpCircle, Star } from "lucide-react"
import "../Css_files/About_us.css"
import Navbar from "./Navbar"
import Footer from "./Footer"
import img from "../Images/MDimage.jpg"
import img1 from "../Images/Testimonial 1 (1).png"
import img2 from "../Images/Testimonial 1 (2).png"
import img3 from "../Images/Testimonial 1 (3).png"

// About Header Component
const AboutHeader = () => (
  <section className="about-header">
    <div className="about-container">
      <h1 className="about-main-title">About Profenaa Technologies Online</h1>
      <p className="about-subtitle">Empowering Learners Globally through Online Education</p>
    </div>
  </section>
)

// About Content Component
const AboutContent = () => (
  <section className="about-content-section">
    <div className="about-container">
      <div className="about-content-grid">
        <div className="about-image-container">
          <img src={img || "/placeholder.svg"} alt="Online Learning" className="about-main-image" />
        </div>
        <div className="about-text-content">
          <h2 className="about-section-title">Leading Online Learning Platform</h2>
          <p className="about-description">
            Profenaa Technologies Online delivers high-quality education across multiple disciplines including Mechanical, Civil, Electronics & Communication, Computer Science, Arts, and Multimedia. Our mission is to make learning accessible and impactful for students worldwide.
          </p>
          <p className="about-description">
            Through live online classes, interactive workshops, real-time projects, and personalized mentorship, our learners gain practical skills that prepare them for global career opportunities.
          </p>
        </div>
      </div>
    </div>
  </section>
)

// Our Journey Component
const OurJourney = () => {
  const journeyMilestones = [
    { year: "2015", title: "Foundation", description: "Profenaa Technologies was established to provide quality technical education online and offline." },
    { year: "2017", title: "Course Expansion", description: "Expanded offerings to Civil and Electronics & Communication disciplines." },
    { year: "2019", title: "Creative Courses", description: "Introduced Arts and Multimedia courses to embrace creativity and digital skills." },
    { year: "2021", title: "Digital Transformation", description: "Launched full-fledged online learning platforms and hybrid courses." },
    { year: "2023", title: "Global Recognition", description: "Achieved recognition as a trusted online education platform serving learners worldwide." },
  ]

  return (
    <section className="about-journey-section">
      <div className="about-container">
        <h2 className="about-section-title about-center">Our Journey</h2>
        <div className="about-journey-timeline">
          {journeyMilestones.map((m, index) => (
            <div key={index} className="about-timeline-item">
              <div className="about-timeline-year">{m.year}</div>
              <div className="about-timeline-content">
                <h3 className="about-timeline-title">{m.title}</h3>
                <p className="about-timeline-description">{m.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

// Vision & Mission Component
const VisionMission = () => (
  <section className="about-vision-mission-section">
    <div className="about-container">
      <div className="about-vision-mission-grid">
        <div className="about-vision-card">
          <div className="about-card-icon"><Eye className="about-icon" /></div>
          <h3 className="about-card-title">Our Vision</h3>
          <p className="about-card-description">
            To be a leading online learning platform that transforms students into skilled professionals, fostering innovation and digital expertise across technical and creative fields.
          </p>
        </div>
        <div className="about-mission-card">
          <div className="about-card-icon"><Target className="about-icon" /></div>
          <h3 className="about-card-title">Our Mission</h3>
          <p className="about-card-description">
            To deliver practical, interactive, and industry-aligned online programs that equip learners with the skills and confidence to excel globally in their chosen domains.
          </p>
        </div>
      </div>
    </div>
  </section>
)

// Why Choose Us Component
const WhyChooseUs = () => {
  const reasons = [
    { icon: <Award className="about-feature-icon" />, title: "Industry-Experienced Faculty", description: "Learn from instructors with real-world experience in global industries." },
    { icon: <BookOpen className="about-feature-icon" />, title: "Comprehensive Curriculum", description: "Courses updated regularly to match latest industry trends and standards." },
    { icon: <Users className="about-feature-icon" />, title: "Hands-on Projects", description: "Work on real-time projects and virtual labs to enhance practical skills." },
    { icon: <Target className="about-feature-icon" />, title: "Career Support", description: "Guidance for interviews, portfolio building, and job placement assistance." },
    { icon: <Heart className="about-feature-icon" />, title: "Learner-Centric Approach", description: "Personalized mentoring and flexible schedules for global learners." },
    { icon: <Star className="about-feature-icon" />, title: "Proven Success", description: "Thousands of learners placed in top companies worldwide after completing online courses." },
  ]

  return (
    <section className="about-why-choose-section">
      <div className="about-container">
        <h2 className="about-section-title about-center">Why Choose Profenaa Online?</h2>
        <div className="about-features-grid">
          {reasons.map((r, i) => (
            <div key={i} className="about-feature-card">
              <div className="about-feature-icon-container">{r.icon}</div>
              <h3 className="about-feature-title">{r.title}</h3>
              <p className="about-feature-description">{r.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

// FAQ Component (similar, no changes needed for online context)
const FAQ = () => {
  // Keep the FAQ code as is, categories & answers already online-focused
  // ...
}

// Testimonial Slider Component
const TestimonialSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0)

  const testimonials = [
    { name: "Rajesh Kumar", course: "Mechanical Engineering - CAD/CAM", image: img1, rating: 5, text: "Hands-on online training transformed my career. Faculty guidance and projects helped me land a top job." },
    { name: "Priya Sharma", course: "Computer Science - Full Stack Development", image: img2, rating: 5, text: "Project-based learning and expert mentorship boosted my coding and job skills." },
    { name: "Arun Patel", course: "Civil Engineering - STAAD Pro", image: img3, rating: 5, text: "Comprehensive online curriculum and software training prepared me for construction projects." },
    { name: "Sneha Reddy", course: "Arts & Design - UI/UX", image: "/placeholder.svg?height=100&width=100", rating: 5, text: "Creative projects and portfolio guidance helped me secure a top design job." },
    { name: "Vikram Singh", course: "Electronics - Embedded Systems", image: "/placeholder.svg?height=100&width=100", rating: 5, text: "Practical labs and project work gave me strong understanding of electronics." },
    { name: "Kavya Nair", course: "Multimedia - Video Production", image: img3, rating: 5, text: "Industry-standard software training prepared me for multimedia careers." },
  ]

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % testimonials.length)
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length)

  useEffect(() => {
    const timer = setInterval(nextSlide, 5000)
    return () => clearInterval(timer)
  }, [])

  const getVisibleTestimonials = () => {
    const visible = []
    for (let i = -1; i <= 1; i++) {
      const index = (currentSlide + i + testimonials.length) % testimonials.length
      visible.push({ ...testimonials[index], position: i })
    }
    return visible
  }

  return (
    <section className="about-testimonial-section">
      <div className="about-container">
        <h2 className="about-testimonial-title">Student Success Stories</h2>
        <div className="about-testimonial-slider-wrapper">
          <button className="about-testimonial-nav about-nav-prev" onClick={prevSlide}>
            <ChevronLeft className="about-nav-icon" />
          </button>
          <div className="about-testimonial-cards-container">
            {getVisibleTestimonials().map((t, idx) => (
              <div
                key={`${t.name}-${currentSlide}-${idx}`}
                className={`about-testimonial-card-new ${
                  t.position === 0 ? "about-card-center" : t.position === -1 ? "about-card-left" : "about-card-right"
                }`}
              >
                <div className="about-testimonial-profile">
                  <div className="about-profile-image-wrapper">
                    <img src={t.image || "/placeholder.svg?height=100&width=100"} alt={t.name} className="about-profile-image" />
                  </div>
                </div>
                <div className="about-testimonial-content-new">
                  <div className="about-quote-mark">"</div>
                  <h4 className="about-testimonial-name-new">{t.name}</h4>
                  <p className="about-testimonial-text-new">{t.text}</p>
                  <div className="about-testimonial-rating-new">
                    {[...Array(t.rating)].map((_, i) => (<Star key={i} className="about-star-icon" />))}
                  </div>
                  <p className="about-testimonial-course-new">{t.course}</p>
                </div>
              </div>
            ))}
          </div>
          <button className="about-testimonial-nav about-nav-next" onClick={nextSlide}>
            <ChevronRight className="about-nav-icon" />
          </button>
        </div>
      </div>
    </section>
  )
}

// Main About Page Component
const Aboutus = () => (
  <div className="about-page">
    <Navbar />
    <br /><br />
    <AboutHeader />
    <AboutContent />
    <OurJourney />
    <VisionMission />
    <WhyChooseUs />
    <FAQ />
    <TestimonialSlider />
    <Footer />
  </div>
)

export default Aboutus
